export default "__VITE_ASSET__DXa7yw9L__"